"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MerchantOverrides = void 0;

var _borderRadius = require("../../themes/merchant/borderRadius");

var _borderWidth = require("../../themes/merchant/borderWidth");

var _constants = require("../../theming/modal/constants");

var _color = require("../../themes/merchant/color");

var _textStyle = require("../../themes/merchant/textStyle");

var _shape = require("../../themes/merchant/shape");

var _size = require("../../themes/merchant/size");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MerchantOverrides = {
  BorderRadius: _objectSpread({}, _borderRadius.Semantics),
  BorderWidth: _objectSpread({}, _borderWidth.Semantics),
  Colors: _objectSpread({}, _color.Semantics),
  Modal: {
    closeButtonSide: _constants.CloseSides.Trailing,
    hasDynamicPadding: true,
    titleSize: 24
  },
  Popover: {
    showContainerPointer: false
  },
  Shape: _objectSpread({}, _shape.Semantics),
  Size: _objectSpread({}, _size.Semantics),
  Typography: {
    TextStyles: _objectSpread({}, _textStyle.Semantics)
  }
};
exports.MerchantOverrides = MerchantOverrides;